import { atom } from 'recoil';

export const pageNumberAtom = atom({
  key: 'pageNumberAtom',
  default: 1,
});
